var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVegetables26 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "700.093px",
    height: "683.805px",
    viewBox: "0 0 700.093 683.805",
    enableBackground: "new 0 0 700.093 683.805",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.056,384.266l18.143,248.097c5.034,68.934-285.475,68.244-280.976,0 l16.219-246.795C311.957,387.981,397.829,388.331,478.056,384.266L478.056,384.266z M350.051,0 c193.309,0,350.042,100.028,350.042,223.427S528.46,348.551,335.161,348.551C141.832,348.551,0,346.827,0,223.427 S156.737,0,350.051,0L350.051,0z M115.068,301.53c-6.201-68.47-0.968-124.731,29.97-169.167l-52.933-12.851 C28.037,181.921,27.607,276.809,115.068,301.53L115.068,301.53z M164.443,109.395c14.165-13.977,31.722-26.536,53.333-37.684 c-36.88,8.294-67.187,17.715-91.229,28.455L164.443,109.395z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVegetables26, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vegetables-26.4818d250.svg";
export { ForwardRef as ReactComponent };